import { DialogContentText, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { RaiseQuery } from '../raiseQuery/RaiseQuery';
import { StartupViewQuery } from './StartupViewQuery';
import { ViewMilestoneQuery } from './ViewMilestoneQuery';
import { useViewQuery } from './useViewQuery';

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

export const ViewQuery: React.FunctionComponent<any> = ({
  queryKeys,
  queryType,
  open,
  setOpen,
  totalFieldQueries,
  totalSectionQueries,
  fieldQueries,
  getSivReportQueries,
  setQueryType,
  report_id,
  isSQSivQueries
}) => {
  const {
    expanded,
    handleChangeAccordion,
    anchorEl,
    openMore,
    handleClick,
    handleCloseMore,
    resTexts,
    setResTexs,
    sendQueryRes,
    handleTextChange,
    setDeleteType,
    handleDeleteFieldQuery,
    enable,
    handleDialoBox,
    handleDialogClose,
    currentId,
    setCurrentId,
    setForwardQuery,
    openForwardQuery,
    reportQueryId,
    confirmDailog,
    handleForwardDialogBox,
    prevAssign,
    setConfirmDailog,
    handleResolveQuery,
    setResloveQueryId,
    handleRespondAlFieldQueries,
    handleRespondAllSectionQueries,
    respondFieldQueries,
    respondSectionQueries,
    setAnchorEl,
    setExpanded,
    forwardQueryId
  } = useViewQuery(getSivReportQueries, fieldQueries, queryKeys, setOpen);
  const { checkPermission } = usePermissionWrapper();

  const perDisable = checkPermission(
    queryKeys?.report_category === 'SQREPT' ||
      queryKeys?.report_category === 'SUSIVRT' ||
      queryKeys?.report_category === 'SUMILST'
      ? queryKeys?.report_category === 'SQREPT'
        ? 'raise_query_sq_report'
        : queryKeys?.report_category === 'SUSIVRT'
        ? 'raise_query_siv_report'
        : queryKeys?.report_category === 'SUMILST'
        ? 'raise_query_milestone'
        : ''
      : ''
  );
  return (
    <div>
      <div className="modal-view">
        <PopupComponent aria-labelledby="customized-dialog-title" open={open} maxWidth="md">
          <DialogContent dividers className="audit-history-modal" sx={{ minWidth: 600, maxHeight: '82vh' }}>
            {/* <ProgressBarComponent></ProgressBarComponent> */}
            <div className="audit-card sivreport-audit-history">
              <Grid container spacing={3}>
                <Grid item md={12}>
                  <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', pt: 0 }}>
                    {isSQSivQueries ? (
                      <StartupViewQuery
                        queryKeys={queryKeys}
                        queryType={queryType}
                        totalFieldQueries={totalFieldQueries}
                        totalSectionQueries={totalSectionQueries}
                        fieldQueries={fieldQueries}
                        setQueryType={setQueryType}
                        perDisable={perDisable}
                        expanded={expanded}
                        handleChangeAccordion={handleChangeAccordion}
                        anchorEl={anchorEl}
                        openMore={openMore}
                        handleClick={handleClick}
                        handleCloseMore={handleCloseMore}
                        resTexts={resTexts}
                        setResTexs={setResTexs}
                        sendQueryRes={sendQueryRes}
                        handleTextChange={handleTextChange}
                        setDeleteType={setDeleteType}
                        handleDialoBox={handleDialoBox}
                        currentId={currentId}
                        setCurrentId={setCurrentId}
                        handleForwardDialogBox={handleForwardDialogBox}
                        setConfirmDailog={setConfirmDailog}
                        setResloveQueryId={setResloveQueryId}
                        handleRespondAlFieldQueries={handleRespondAlFieldQueries}
                        handleRespondAllSectionQueries={handleRespondAllSectionQueries}
                        respondFieldQueries={respondFieldQueries}
                        respondSectionQueries={respondSectionQueries}
                      />
                    ) : (
                      <ViewMilestoneQuery
                        queryKeys={queryKeys}
                        queryType={queryType}
                        totalFieldQueries={totalFieldQueries}
                        totalSectionQueries={totalSectionQueries}
                        fieldQueries={fieldQueries}
                        setQueryType={setQueryType}
                        perDisable={perDisable}
                        expanded={expanded}
                        handleChangeAccordion={handleChangeAccordion}
                        anchorEl={anchorEl}
                        openMore={openMore}
                        handleClick={handleClick}
                        handleCloseMore={handleCloseMore}
                        resTexts={resTexts}
                        setResTexs={setResTexs}
                        sendQueryRes={sendQueryRes}
                        handleTextChange={handleTextChange}
                        setDeleteType={setDeleteType}
                        handleDialoBox={handleDialoBox}
                        currentId={currentId}
                        setForwardQuery={setForwardQuery}
                        setCurrentId={setCurrentId}
                        handleForwardDialogBox={handleForwardDialogBox}
                        setConfirmDailog={setConfirmDailog}
                        setResloveQueryId={setResloveQueryId}
                        handleRespondAlFieldQueries={handleRespondAlFieldQueries}
                        handleRespondAllSectionQueries={handleRespondAllSectionQueries}
                        respondFieldQueries={respondFieldQueries}
                        respondSectionQueries={respondSectionQueries}
                      />
                    )}
                  </Box>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
          <PopupComponent
            open={enable}
            child
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{'Remove Query?'}</DialogTitle>
            <DialogContent sx={{ minWidth: '360px' }}>
              <DialogContentText sx={{ fontSize: '16px' }} id="alert-dialog-description">
                Do you want to remove query?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setAnchorEl(null);
                  handleDialogClose();
                }}
                className="grey-btn"
              >
                No
              </Button>
              <Button onClick={() => handleDeleteFieldQuery()} autoFocus>
                Yes
              </Button>
            </DialogActions>
          </PopupComponent>
          <PopupComponent
            open={confirmDailog}
            child
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{'Confirmation'}</DialogTitle>
            <DialogContent sx={{ minWidth: '360px' }}>
              <DialogContentText sx={{ fontSize: '16px' }} id="alert-dialog-description">
                Mark the Query as Resolved
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setConfirmDailog(false)} className="grey-btn">
                Cancel
              </Button>
              <Button onClick={() => handleResolveQuery()} autoFocus>
                Confirm
              </Button>
            </DialogActions>
          </PopupComponent>
          <DialogActions>
            <Stack direction="row" spacing={2}>
              <Button
                variant="text"
                href="#contained-buttons"
                className="grey-btn"
                onClick={() => {
                  setResTexs({});
                  setOpen(false);
                  setExpanded(false);
                }}
              >
                Close
              </Button>
            </Stack>
          </DialogActions>
        </PopupComponent>
      </div>
      <div>
        <RaiseQuery
          openRaiseQuery={openForwardQuery}
          setOpenRaiseQuery={setForwardQuery}
          queryKeys={queryKeys}
          queryType={queryType}
          getSivReportQueries={getSivReportQueries}
          reportQueryId={reportQueryId}
          report_id={report_id}
          prevAssign={prevAssign}
          fieldQueries={fieldQueries}
          forwardQueryId={forwardQueryId}
        />
      </div>
    </div>
  );
};
